import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 10.3 18.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10.3 18.7\" id=\"icon-chevron-right\">\r\n<path d=\"M1,18.7c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.6-7.6L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L10,8.6\r\n\tc0.4,0.4,0.4,1,0,1.4l-8.3,8.3C1.5,18.6,1.3,18.7,1,18.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol